"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompaniesService = void 0;
var OpenAPI_1 = require("../core/OpenAPI");
var request_1 = require("../core/request");
var CompaniesService = /** @class */ (function () {
    function CompaniesService() {
    }
    /**
     * Index Builder Profile
     * Index a company
     * @param cid The company id
     * @returns team_graph__logic__companies__BatchIndexResult Successful Response
     * @throws ApiError
     */
    CompaniesService.indexBuilderProfile = function (cid) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'POST',
            url: '/companies/{cid}',
            path: {
                'cid': cid,
            },
            errors: {
                422: "Validation Error",
            },
        });
    };
    return CompaniesService;
}());
exports.CompaniesService = CompaniesService;
//# sourceMappingURL=CompaniesService.js.map